import { useSelector } from 'react-redux';
import { RootState } from '../service/store';

export const checkPermission = (isAdmin: boolean, permission: any, action: string): boolean => {
    // If isAdmin is true, grant all permissions
    if (isAdmin) {
        return true;
    }

    // Permission levels: 1 = view, 2 = edit
    const permissionLevel = permission || 2;

    switch (action) {
        case 'view':
            return permissionLevel >= 1;
        case 'edit':
            return permissionLevel >= 2;
        default:
            return false;
    }
};

export const usePermission = () => {
    const workbenchPermission = useSelector((state: RootState) => state?.static?.workbenchPermission);
    const isAdmin = useSelector((state: RootState) => state?.static?.isAdmin);

    const canView = checkPermission(isAdmin, workbenchPermission, 'view');
    const canEdit = checkPermission(isAdmin, workbenchPermission, 'edit');

    return {
        isAdmin,
        workbenchPermission,
        canView,
        canEdit,
        // Allow checking custom permissions as well
        checkPermission: (action: string) => checkPermission(isAdmin, workbenchPermission, action)
    };
};